<template>
	<div>
		<form-errors v-if="hasErrors" :errors="[ errorText ]"></form-errors>
		<button v-if="!loading" type="submit" :class="`${ type }-bg`">{{ text }}<span class="fa" :class="icon"></span></button>
		<button v-else type="submit" class="processing brand-bg"><img src="/images/spinner.svg" class="fa fa-spin spinner"></button>
	</div>
</template>

<script>

export default {

	props: {
		loading: {
			type: Boolean,
			default: false,
		},

		text: {
			type: String,
			default: 'Submit Now',
		},

		icon: {
			type: String,
			default: 'fa-key',
		},

		processingText: {
			type: String,
			default: 'Processing',
		},

		errorText: {
			type: String,
			default: 'Unable to Process Request',
		},

		hasErrors: {
			type: Boolean,
			default: false,
		},

		type: {
			type: String,
			default: 'brand',
		},
	},

};

</script>
